import React, {useEffect, useState} from "react";
import {PhishToolbar} from './PhishToolbar'
import {TreeView} from "@material-ui/lab";
import {ChevronRight, ExpandMore} from "@material-ui/icons";

import {ClientView} from "./ClientView";
import axios from "axios";
import {saveAs} from 'file-saver';
import Groupbox from "../core/Groupbox";
import {
    Avatar,
    Button,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Toolbar, Tooltip,
    Typography
} from "@material-ui/core";
import {MyTargetsView} from "./MyTargetsView";
import {SHOW_AXIOS_ERROR} from "../core/FUNCS";
import {RseDialog} from "./NewRseDialog";
import {CampaignDialog} from "./CampaignDialog";
import {SendTemplateDialog} from './SendTemplateDialog';
import {ErrorBar, MessageBar} from "./Bars";
import dateHelper from "../core/dateHelper";
import {CONSTS} from './CONSTS'
import AddIcon from "@material-ui/icons/Add";
import AlertDialog from "./AlertDialog";
import DropDownButton from "./DropDownButton";
import {CheckBox} from "@mui/icons-material";
import {Checkbox} from "@mui/material";
import {TimelineDialog} from "./TimelineDialog";


//axios.defaults.baseURL = 'https://localhost:5001';

//axios.defaults.baseURL = 'https://test.castlegarde.com:5003';

function excludeResultsFromMyTargets(myTargets, results){
    if(!results){
        return myTargets;
    }

    if(!myTargets){
        return myTargets;
    }

    return myTargets.filter(p => !(results.some(pp => pp.email === p.email)));
}

export  function Phish2(props){
    const [isAdmin, setIsAdmin] = useState(false);
    const [error, setError] = useState(null);
    const [docxClients,setDocxClients] = useState([]);
    const [goParameters, setGoParameters] = useState([]);
    const [clientFilter,setClientFilter] = useState(null);
    const [client,setClient] = useState(null);
    const [expanded, setExpanded] = useState([]);
    const [myTargets, setMyTargets] = useState([]);
    const [loadRses, setLoadRses] = useState(() =>()=> alert('Select a client first'));
    const [rse,setRse] = useState(null);
    const [loadCampaigns, setLoadCampaigns] = useState(() => ()=> alert('Select a RSE first'));
    const [campaign,setCampaign] = useState(null);
    const [results, setResults] = useState([]);

    const [showRseDialog, setShowRseDialog] = useState(() => () => alert("no show rse dialog docked"));
    const [showCampaignDialog, setShowCampaignDialog] = useState(() => () =>
        alert('no show campaign dialog docked'));
    const [showSendTemplateDialog, setShowSendTemplateDialog] = useState(() => () =>
        alert('no show send template dialog docked'));
    const [showAlertDialog, setShowAlertDialog] = useState(() => () =>
        alert('no show alert dialog docked'));
    const [showTimelineDialog, setShowTimelineDialog] = useState(() => () =>
        alert("no show timeline dialog docked"));

    const displayError = error => {
        if (error.response) {
            setError(error.response.status + ' ' + error.response.data);
        } else if(error.message) {
            setError(error.message);
        } else{
            setError(error);
        }
    }

    const filterClients = (clients,filter) => {
        let r = clients;
        if(!r ){
            return r;
        }
        if(filter){
            r = clients.filter(p => (p.title && p.title.toUpperCase().startsWith(filter.toUpperCase())));
        }
        //r.sort((a,b) => {
        //    if(a.title > b.title){
        //        return 1;
        //    }
        //    if(a.title < b.title){
        //        return -1;
        //    }
        //    return 0;
        //});

        return r;
    };

    const loadCampaign = (campaign) => {
        axios.get('api/phish/readCampaign/' + campaign.id)
            .then(response => {
                setCampaign(response.data);
                setResults((response.data || {}).results);
            })
            .catch(displayError);}

    const loadClients = () => {
        const url = 'api/phish/docxClients';
        axios.get(url)
            .then(response => setDocxClients(response.data))
            .catch(displayError)
    }

    const loadGoParameters = () => {
        axios.get('api/phish/getGoParameters2')
            .then(response => {
                setGoParameters(response.data);
            })
            .catch(displayError);
    }

    const loadIsAdmin = () => {
        axios.get('api/phish/isAdmin')
            .then(response => {
                setIsAdmin(response.data);
            })
            .catch(() => setIsAdmin(false));
    }

    //useEffect(loadIsAdmin, []);
    //useEffect(loadClients,[])
    //useEffect(loadGoParameters, []);

    useEffect(() => {
        const interval = setInterval(() => {
            if(campaign && campaign.id && campaign.status
                 && campaign.status !== 'Done'){
                loadCampaign(campaign);
            }
        }, 30000);
        return () => clearInterval(interval);
    }, [campaign]); // eslint-disable-line react-hooks/exhaustive-deps

    //if(!isAdmin){
    //    return '';
    //}

    return <div>
        <ErrorBar error={error} onClear={() => setError(null)}/>

        <PhishToolbar
            sendTemplate={() => {
                if(!goParameters || goParameters.length == 0){
                    showAlertDialog("Loading", "Still loading data, please wait",() => {});
                }else{
                    showSendTemplateDialog(sendingTemplate => {
                        axios.post('api/phish/sendTemplate', sendingTemplate)
                            .then(response => alert("sent templates"))
                            .catch(displayError);
                    });
                }
            }}

            clientFilter={clientFilter}
            onClientFilter={value => setClientFilter(value)}

            isAllowNewRse={client && loadRses}
            newRse={() => {
                showRseDialog({clientId:client.id, clientTitle:client.title},
                        rse => {
                    rse.clientId = client.id;
                    axios.post('api/phish/newRse',rse)
                        .then(response => {
                            loadRses();
                        })
                        .catch(displayError);
                });
            }}

            isAllowDeleteRse={rse}
            deleteRse={() => {
                
                showAlertDialog((rse || {}).title,
                    `Are you sure to delete this RSE: ${(rse || {}).title} of ${(client || {}).title} `,
                    () => {
                        axios.get('api/phish/deleteRse/' + rse.id)
                            .then(response => {
                                loadRses();
                            })
                            .catch(SHOW_AXIOS_ERROR);
                    })
            }}

            isAllowClearTargets={client}
            clearTargets={() => {
                showAlertDialog("Delete all employees",
                    `Are you sure to delete all employees from ${(client || {}).title} `,
                    () => {
                        axios.get('api/phish/clearTargets/' + client.id)
                            .then(response => {
                                axios.get('api/phish/readTargets/' + client.id)
                                    .then(response => setMyTargets(response.data))
                                    .catch(SHOW_AXIOS_ERROR);
                            })
                            .catch(displayError);
                    })
            }}

            isAllowNewCampaign={rse}
            newCampaign={() => {
                if(!goParameters || goParameters.length == 0){
                    showAlertDialog("Loading", "Still loading data, please wait",() => {});
                }else {
                    showCampaignDialog({clientTitle: client.title, tag2: rse.title},
                        campaign => {
                            const url = 'api/phish/newCampaign/' + rse.id;
                            axios.post(url, campaign)
                                .then(response => {
                                    loadCampaigns();
                                })
                                .catch(displayError);
                        });
                }
            }}
            isAllowEditCampaign={campaign}
            editCampaign={() => {
                if(!goParameters || goParameters.length == 0){
                    showAlertDialog("Loading", "Still loading data, please wait",() => {});
                }else {
                    //alert('haha');
                    //return;
                    showCampaignDialog(campaign, campaign => {
                        campaign.status = null;
                        const url = 'api/phish/updateCampaign';
                        axios.post(url, campaign)
                            .then(response => {
                                loadCampaigns();
                            })
                            .catch(displayError);
                    });
                }
            }}
            isAllowStart={campaign && !campaign.status}
            startCampaign={() => {
                showAlertDialog(campaign.sendingProfile + ' (' +
                        dateHelper.toShortDateRange(campaign.start, campaign.end) + ')',
                    `Are you sure to start this campaign for ${(rse || {}).title} of ${(client || {}).title} `,
                    () => {
                    axios.get('api/phish/startCampaign/' + campaign.id)
                        .then(response => {
                            setCampaign(response.data);
                            setResults((response.data || {}).results);
                            axios.get('api/phish/readTargets/' + client.id)
                                .then(response => setMyTargets(response.data))
                                .catch(SHOW_AXIOS_ERROR);
                        })
                        .catch(displayError);
                })
            }}
            isAllowStop={campaign && campaign.status === 'In progress'}
            stopCampaign={() => {
                axios.get('api/phish/completeCampaign/' + campaign.id)
                    .then(response => {
                        setCampaign(response.data);
                    })
                    .catch(displayError);
            }}
            isAllowDeleteCampaign={campaign}
            deleteCampaign={() => {
                showAlertDialog(campaign.sendingProfile + ' (' +
                    dateHelper.toShortDateRange(campaign.start, campaign.end) + ')',
                    `Are you sure to delete this campaign for ${(rse || {}).title} of ${(client || {}).title} `,
                    () => {
                        axios.get('api/phish/deleteCampaign/' + campaign.id)
                            .then(response => {
                                loadCampaigns();
                            })
                            .catch(SHOW_AXIOS_ERROR);
                    })
            }}
            isAllowReport={rse}
            reportCampaign={() => {
                //const url = 'https://localhost:5001/api/phish/reportCampaign/' + rse.id;
                const url = 'api/phish/reportCampaign/' + rse.id;
                saveAs(url);
            }}
        />
        <div style={{ display: 'flex' }}>
            <div style={{ flex: 1, overflowY: 'scroll', height: '80vh', overflowX: 'auto' }}>
                <TreeView expanded={expanded}
                    aria-label="file system navigator"
                    defaultCollapseIcon={<ExpandMore />}
                    defaultExpandIcon={<ChevronRight />}
                    sx={{ height: 240, flexGrow: 1, maxWidth: 400, overflowY: 'auto' }}
                >
                    {
                        filterClients(docxClients,clientFilter).map(docxClient =>
                            <ClientView
                                key={docxClient.id}
                                docxClient={docxClient}
                                onClientSelected={(client, loadMyChildren) => {
                                    setLoadRses(()=> loadMyChildren);
                                    setClient(client);
                                    setExpanded([client.id]);
                                    setRse(null);
                                    setCampaign(null);
                                    setResults([]);
                                    axios.get('api/phish/readTargets/' + client.id)
                                        .then(response => setMyTargets(response.data))
                                        .catch(SHOW_AXIOS_ERROR);
                                }}
                                onRseSelected={(rse,loadMyChildren) => {
                                    setRse(rse);
                                    setExpanded([rse.clientId,rse.id]);
                                    setCampaign(null);
                                    setLoadCampaigns(() =>loadMyChildren);
                                    setResults([]);
                                }}
                                onCampaignSelected={loadCampaign}
                            />
                        )
                    }
                </TreeView>
            </div>
            <div style={{ flex: 2 ,overflowY: 'scroll', height: '80vh', overflowX: 'auto' }}>
                <Groupbox header='Targets' >
                    <div style={{height:'400px', overflowX:'auto'}}>
                        <MyTargetsView disabled={!client}
                            onUpload={file => {
                            const url = 'api/phish/importTargets/' + client.id;
                            let data = new FormData();
                            data.append('file', file, file.name);
                            axios.post(url,
                                data,
                                {
                                    headers: {
                                        'accept': 'application/json',
                                        'Accept-Language': 'en-US,en;q=0.8',
                                        'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
                                    }
                                }
                            ).then(response => {
                                setMyTargets(response.data);
                            }).catch(displayError);
                        }}

                        onDoubleClick={id => {
                            if(campaign && campaign.id){
                                const url = 'api/phish/AddTargetToCampaign/' + id + '/' + campaign.id;
                                //alert(url);
                                axios.get(url)
                                    .then(response => {
                                        axios.get('api/phish/readResults/' + campaign.id)
                                            .then(reponse => setResults(response.data.results))
                                            .catch(SHOW_AXIOS_ERROR);
                                    })
                                    .catch(SHOW_AXIOS_ERROR);
                            }
                        }}
                        items={excludeResultsFromMyTargets(myTargets, results)}/>
                    </div>
                </Groupbox>
                <Toolbar style={{ backgroundColor: (campaign && (campaign.status === CONSTS.CampaignInProgress))?'#D6FFB7':'#eee',
                    boxShadow: '3px 3px #ccc', borderRadius: '3px', marginTop:'-20px', marginBottom:'-10px'}}>
                    <Avatar
                            style={{ marginRight: '30px', backgroundColor:'lightblue' }} variant='rounded'>{(myTargets || []).length}</Avatar>

                    <DropDownButton addBatchTargetToCampaign={(number) => {
                        if(campaign && campaign.id){
                            const url = 'api/phish/addBatchTargetToCampaign/' + client.id + '/' + campaign.id + '/' + number;
                            axios.get(url)
                                .then(response => {
                                    axios.get('api/phish/readResults/' + campaign.id)
                                        .then(reponse => setResults(response.data.results))
                                        .catch(SHOW_AXIOS_ERROR);
                                })
                                .catch(SHOW_AXIOS_ERROR);
                        }
                    }} clearAllTargetFromCampaign={() => {
                        if(campaign && campaign.id){
                            const url = 'api/phish/clearAllTargetFromCampaign/' + campaign.id;
                            axios.get(url)
                                .then(response => {
                                    axios.get('api/phish/readResults/' + campaign.id)
                                        .then(reponse => setResults(response.data.results))
                                        .catch(SHOW_AXIOS_ERROR);
                                })
                                .catch(SHOW_AXIOS_ERROR);
                        }
                    }}
                    />
                    <Avatar
                        style={{ marginLeft: '30px', backgroundColor:'orange' }}>{(results || []).length}</Avatar>
                    <Typography
                        color="primary" style={{ marginLeft: '10px' }}>Status:{(campaign || {}).status}</Typography>
                    <Typography
                        color="primary" style={{ marginLeft: '10px' }}>Start:{dateHelper.toShortDateTime((campaign || {}).start)}</Typography>
                    <Typography
                        color="primary" style={{ marginLeft: '10px' }}>Sent:{(campaign || {}).emailsSent}</Typography>
                    <Typography
                        color="primary" style={{ marginLeft: '10px' }}>Opened:{(campaign || {}).emailsOpened}
                    </Typography>
                    <Typography
                        color="secondary" style={{ marginLeft: '10px' }}>Clicked:{(campaign || {}).emailsClicked}
                    </Typography>
                </Toolbar>
                <Groupbox header='Phish Results' >
                    <div style={{height:'500px', overflowX:'auto'}}>
                        <Table size='small'>

                            <TableHead>
                                <TableRow>
                                    <TableCell align='left'>Full Name</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>False Positive</TableCell>
                                    <TableCell>Sent</TableCell>
                                    <TableCell>Opened</TableCell>
                                    <TableCell>Clicked</TableCell>
                                    <TableCell>IP</TableCell>
                                </TableRow>

                            </TableHead>
                            <TableBody>
                                {
                                    results.map(result => <TableRow
                                        key={result.id}
                                        onDoubleClick={() => {
                                        if(campaign && campaign.id){
                                            const url = 'api/phish/removeTargetFromCampaign/' + result.id + '/' + campaign.id;
                                            //alert(url);
                                            axios.get(url)
                                                .then(response => {
                                                    axios.get('api/phish/readResults/' + campaign.id)
                                                        .then(reponse => setResults(response.data.results))
                                                        .catch(SHOW_AXIOS_ERROR);
                                                })
                                                .catch(SHOW_AXIOS_ERROR);
                                        }
                                    }}>
                                        <TableCell align='left'>{result.name}</TableCell>
                                        <TableCell>{result.email}</TableCell>
                                        {
                                            /*
                                            <TableCell>{
                                            result.status === CONSTS.EmailSent?
                                                <Chip label={result.status} color='primary' variant='outlined'/>:
                                                result.status === CONSTS.EmailOpened?
                                                    <Chip label={result.status} color='primary' variant='outlined'/>:
                                                    result.status === CONSTS.ClickedLink?
                                                        <Chip label={result.status} color='secondary' variant='outlined'/>:
                                                        result.status === CONSTS.SubmittedData?
                                                            <Chip label={result.status} color='primary'/>:
                                                            !result.status?
                                                                '':
                                                                <Chip label={result.status} color='primary' variant='outlined'/>

                                        }</TableCell>
                                             */
                                        }

                                        <TableCell>
                                            <Button onClick={() => {
                                                const timelineItems = JSON.parse(result.tag3)
                                                showTimelineDialog(timelineItems);
                                            }}>
                                                <Chip label={result.status || ''} color={result.status === CONSTS.ClickedLink ? 'secondary' : 'primary'} variant='outlined'/>
                                            </Button>

                                        </TableCell>
                                        <TableCell>
                                            <Tooltip title={result.tag}>
                                                <Checkbox size='small'  checked={result.tag2}
                                                          onChange={e => {
                                                              if(e.target.checked){
                                                                  result.tag2 = "true";
                                                              }else{
                                                                  result.tag2 = null;
                                                              }
                                                              const url = 'api/phish/ChangeFalsePositiveForResult/' + campaign.id;
                                                              //alert(url);
                                                              axios.post(url, result)
                                                                  .then(response => {
                                                                      setResults(response.data.results)
                                                                  }).catch(SHOW_AXIOS_ERROR);
                                                          }}/>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell>{result.emailSentDate2}</TableCell>
                                        <TableCell>{result.emailOpenedDate2}</TableCell>
                                        <TableCell>{result.clickedLinkDate2}</TableCell>
                                        <TableCell>{result.ip}</TableCell>
                                    </TableRow>)
                                }
                            </TableBody>
                        </Table>
                    </div>

                </Groupbox>
            </div>

            <RseDialog
                onDock={show => setShowRseDialog(() => show)}/>
            <CampaignDialog
                       onDock={show => setShowCampaignDialog(() => show)}
                       goParameters = {goParameters}
            />
            <SendTemplateDialog
                goParameters = {goParameters}
                onDock={show => setShowSendTemplateDialog(() => show)}
            />
            <AlertDialog
                onDock={show => setShowAlertDialog(() => show)}/>
            <TimelineDialog
                onDock={show => setShowTimelineDialog(() => show)}/>
        </div>
        <MessageBar message={(docxClients && docxClients.length > 0 && goParameters && goParameters.length > 0)?'Done with loading data':'Loading data, please wait...'}/>
    </div>
}